/*
    Save properties to browser local storage, for later usage with submitting the signup, and ahoy forms. 
    Data is saved per user using twilio visitor id, example local storage entry: 
    '{"VI000000000000000000000000001":{"gclid":null,"client_id":"1000000.1000000","session_id":"10000000","groupId":null}}'
*/

export const updateLocalStorage = (propertiesKey, newProperties) => {
    
    //if localStorage not supported or user data doesn't exist, return
    if (!localStorage || !window.twilio || !window.twilio.visitor || !window.twilio.visitor.sid)
        return; 
    let visitorSid = window.twilio.visitor.sid;
   
    let properties = {};

    const propertiesString = localStorage.getItem(propertiesKey);
    //if some properties already exist parse them first
    if(propertiesString){
        try {
            properties = JSON.parse(propertiesString);
        } catch (error) {
            console.error(`Cannot parse existing properties : ${propertiesString}`);
        }
    }
    //save the properties for this user
    properties[visitorSid] = newProperties;

    //save all properties to local storage
    localStorage.setItem(propertiesKey, JSON.stringify(properties));
}



// WEBPACK FOOTER //
// ./src/js/local-storage.js